import { EntityStatus } from '../../../core/interfaces/entity-status';
import { Enum } from '../../../core/interfaces/object-enum';

export class InvoiceStatusEnum extends Enum {
  static OPEN = new EntityStatus('open', 'PAYMENT DUE', 'warning');
  static PAID = new EntityStatus('paid', 'PAID', 'success');
  static FAILED = new EntityStatus('failed', 'PAYMENT FAILED', 'error');
}
